import { StylesheetStyle } from 'cytoscape';

const styles = [
  {
    selector: 'node',
    style: {
      shape: 'rectangle',
    },
  },
  {
    selector: 'node.aux',
    style: {
      label: 'data(label)',
      width: '5px',
      height: '5px',
      'background-color': '#44bd32',
    },
  },
  {
    selector: 'node.output',
    style: {
      shape: 'roundrectangle',
      width: '200px',
      height: '25px',
      'text-valign': 'center',
      'text-halign': 'center',
      'background-color': '#44bd32',
    },
  },
  {
    selector: 'node.logic',
    style: {
      shape: 'roundrectangle',
      width: '180px',
      'background-color': 'gray',
      margin: '100px',
    },
  },
  {
    selector: 'node.output',
    style: {
      'margin-top': '30px',
    },
  },
  {
    selector: 'edge',
    style: {
      width: 3,

      'curve-style': 'taxi',

      'edge-distances': 'node-position',

      'target-endpoint': '-50% 0%',
      'source-endpoint': '50% 0%',

      'line-color': '#0097e6',
      'target-arrow-color': '#0097e6',
      'target-arrow-shape': 'triangle',
    },
  },
  {
    selector: 'edge.eh-ghost-edge',
    style: {
      content: '',
      'line-color': '#ccc',
      'target-arrow-color': '#ccc',
      'line-style': 'dashed',
    },
  },
];

export default styles as StylesheetStyle[];
